export function buildPaymentMethodNames(methods: Array<{ id: string; name: string }>) {
  return methods.reduce<Record<string, string>>((acc, method) => {
    acc[method.id] = method.name;
    return acc;
  }, {});
}

/** Etiquetas por defecto cuando el método no está en catálogo (p. ej. ventas históricas con MP QR y flag off). */
export const DEFAULT_PAYMENT_METHOD_LABELS: Record<string, string> = {
  cash: 'Efectivo',
  transfer: 'Transferencia',
  card: 'Tarjeta',
  mercadopago_qr: 'Mercado Pago QR',
  cheque: 'Cheque',
  customer: 'A cuenta',
  fiado: 'A cuenta',
};

export function displayPaymentMethodLabel(methodId: string, names: Record<string, string>): string {
  const fromNames = names[methodId];
  if (fromNames) return fromNames;
  const fallback = DEFAULT_PAYMENT_METHOD_LABELS[methodId];
  if (fallback) return fallback;
  return methodId
    .split('_')
    .map((w) => (w.length ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : w))
    .join(' ');
}
